import { SsmoStepsIdentifiers } from 'modules/onboarding-page/constants';
import { SelfServeStepType } from 'modules/onboarding-page/types';

const isSelfServeStep = (stepParam: string): boolean =>
  Object.values(SsmoStepsIdentifiers).includes(stepParam as SelfServeStepType);

export const validateStepParam = (param: string | null) => {
  if (!param) {
    return null;
  }

  const isValidParam = isSelfServeStep(param);

  return isValidParam ? param.toLowerCase() : null;
};
